/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { AUTH_URL } from './features/apis/baseFectch';
import { User } from './types/userTypes';
import { initializeAgentSessionIds } from './utils/session';

export const userContext = createContext<{
  user: User | undefined;
  setUser: React.Dispatch<React.SetStateAction<User>>;
  token: string;
  loading: boolean;
}>({
  user: {
    _id: '',
    name: '',
    email: '',
    mobile: 0,
    emergency_contact: 0,
    dob: '',
    address: '',
    isUpload: false,
    isDocumentComplete: false,
    designation: '',
    password: '',
    verified: '',
    avatar: '',
    role: '',
    companyId: '',
    leave_data: undefined,
    leave_dates: [],
    createdAt: '',
    isProbationServed: false,
    assigned_HR: '',
    assigned_Manager: '',
    permissions: [],
  },
  setUser: (User) => User,
  loading: false,
  token: '',
});

type props = {
  children: React.ReactNode;
};

const UserContext = ({ children }: props) => {
  const [token, setToken] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState<User>({
    _id: '',
    name: '',
    email: '',
    isUpload: false,
    mobile: 0,
    designation: '',
    emergency_contact: 0,
    dob: '',
    address: '',
    password: '',
    verified: '',
    role: '',
    avatar: '',
    companyId: '',
    leave_data: undefined,
    leave_dates: [],
    createdAt: '',
    isProbationServed: false,
    assigned_HR: '',
    assigned_Manager: '',
    isDocumentComplete: false,
    permissions: [],
  });

  async function fetchCurrrentUser() {
    setLoading(true);
    try {
      const res = await axios.get(`${AUTH_URL}/currentEmployee`, {
        withCredentials: true,
      });
      return res;
    } catch (err) {
      console.log(err, 'error');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (token !== '') {
      fetchCurrrentUser().then((res: any) => {
        if (res === undefined) {
          setUser({
            _id: '',
            name: '',
            email: '',
            mobile: 0,
            emergency_contact: 0,
            dob: '',
            address: '',
            password: '',
            verified: '',
            designation: '',
            role: '',
            avatar: '',
            companyId: '',
            leave_data: undefined,
            leave_dates: [],
            createdAt: '',
            isUpload: false,
            isDocumentComplete: false,
            isProbationServed: false,
            assigned_HR: '',
            assigned_Manager: '',
            permissions: [],
          });
        }
        if (res?.data?.User) {
          initializeAgentSessionIds();
        }
        setUser(res?.data?.User);
      });
    }
  }, [token]);

  useEffect(() => {
    fetchCurrrentUser().then((res: any) => {
      if (res?.data?.User) {
        setUser(res.data.User);
      }
    });
  }, []);

  return (
    <userContext.Provider value={{ user, setUser, loading, token }}>
      {children}
    </userContext.Provider>
  );
};

export default UserContext;
